// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget-container_wrapper__2zh5M"};